<div class="row">
  <div class="col-12">
    <div class="content-header">Grid</div>
  </div>
</div>
<!--Grid options Starts-->
<section id="grid-option">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Bootstrap Grid options</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th></th>
                    <th>Extra small <small>(&lt;576px)</small> </th>
                    <th>Small <small>(≥576px)</small> </th>
                    <th>Medium <small>(≥768px)</small> </th>
                    <th>Large <small>(≥992px)</small> </th>
                    <th>Extra Large <small>(≥1200px)</small> </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="text-nowrap" scope="row">Max container width</th>
                    <td>None (auto)</td>
                    <td>540px</td>
                    <td>720px</td>
                    <td>960px</td>
                    <td>1140px</td>
                  </tr>
                  <tr>
                    <th class="text-nowrap" scope="row">Class prefix</th>
                    <td><code>.col-</code></td>
                    <td><code>.col-sm-</code></td>
                    <td><code>.col-md-</code></td>
                    <td><code>.col-lg-</code></td>
                    <td><code>.col-xl-</code></td>
                  </tr>
                  <tr>
                    <th class="text-nowrap" scope="row"># of columns</th>
                    <td colspan="5">12</td>
                  </tr>
                  <tr>
                    <th class="text-nowrap" scope="row">Gutter width</th>
                    <td colspan="5">30px (15px on each side of a column)</td>
                  </tr>
                  <tr>
                    <th class="text-nowrap" scope="row">Nestable</th>
                    <td colspan="5">Yes</td>
                  </tr>
                  <tr>
                    <th class="text-nowrap" scope="row">Column ordering</th>
                    <td colspan="5">Yes</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
<!--Grid options Ends-->

<!-- Bootstrap Auto Layout Column Starts-->
<section id="auto-layout-columns" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Auto-layout columns</h3>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p class="m-0">Utilize breakpoint-specific column classes for easy column sizing without an explicit numbered class like <code>.col-sm-6</code>.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Bootstrap Auto Layout Column Ends-->

<!--Equal-width Starts-->
<section id="equal-width" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Equal-width</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>For example, here are two grid layouts that apply to every device and viewport, from <code>xs</code> to <code>xl</code>. Add any number of unit-less classes for each breakpoint you need and every column will be the same width.</p>
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col">
                    1 of 2
                  </div>
                  <div class="col">
                    2 of 2
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    1 of 3
                  </div>
                  <div class="col">
                    2 of 3
                  </div>
                  <div class="col">
                    3 of 3
                  </div>
                </div>
              </div>
            </div>
            <pre class="language-markup my-3"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            1 of 2
        &lt;/div&gt;
        &lt;div class="col"&gt;
            2 of 2
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            1 of 3
        &lt;/div&gt;
        &lt;div class="col"&gt;
            2 of 3
        &lt;/div&gt;
        &lt;div class="col"&gt;
            3 of 3
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
          <p>Equal-width columns can be broken into multiple lines, but there was a <a href="https://github.com/philipwalton/flexbugs#11-min-and-max-size-declarations-are-ignored-when-wrapping-flex-items">Safari
              flexbox bug</a> that prevented this from working without an explicit <code>flex-basis</code>
            or <code>border</code>.</p>
          <p>Two workarounds have been documented in a <a href="https://output.jsbin.com/micohor">reduced test case
              outside Bootstrap</a>, though if the browser is up to date this shouldn’t be necessary.</p>
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col">Column</div>
                  <div class="col">Column</div>
                  <div class="w-100"></div>
                  <div class="col">Column</div>
                  <div class="col">Column</div>
                </div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;Column&lt;/div&gt;
        &lt;div class="col"&gt;Column&lt;/div&gt;
        &lt;div class="w-100"&gt;&lt;/div&gt;
        &lt;div class="col"&gt;Column&lt;/div&gt;
        &lt;div class="col"&gt;Column&lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Equal-width Ends-->

<!--Setting one column width Starts-->
<section id="setting-one-column-width" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Setting one column width</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>Auto-layout for flexbox grid columns also means you can set the width of one column and have the sibling columns automatically resize around it. You may use predefined grid classes (as shown below), grid mixins, or inline widths. Note that the other columns will resize no matter the width of the center column.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col">
                    1 of 3
                  </div>
                  <div class="col-6">
                    2 of 3 (wider)
                  </div>
                  <div class="col">
                    3 of 3
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    1 of 3
                  </div>
                  <div class="col-5">
                    2 of 3 (wider)
                  </div>
                  <div class="col">
                    3 of 3
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            1 of 3
        &lt;/div&gt;
        &lt;div class="col-6"&gt;
            2 of 3 (wider)
        &lt;/div&gt;
        &lt;div class="col"&gt;
            3 of 3
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            1 of 3
        &lt;/div&gt;
        &lt;div class="col-5"&gt;
            2 of 3 (wider)
        &lt;/div&gt;
        &lt;div class="col"&gt;
        3 of 3
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Setting one column width Ends-->

<!--Variable width content Starts-->
<section id="variable-width-content" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Variable width content</h4>
      </div>
      <div class="card-body">
        <p>Use <code>col-&#123;breakpoint&#125;-auto</code> classes to size columns based on the natural width of their content.</p>
        <div class="card-content">
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row justify-content-md-center">
                  <div class="col col-lg-2">
                    1 of 3
                  </div>
                  <div class="col-md-auto">
                    Variable width content
                  </div>
                  <div class="col col-lg-2">
                    3 of 3
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    1 of 3
                  </div>
                  <div class="col-md-auto">
                    Variable width content
                  </div>
                  <div class="col col-lg-2">
                    3 of 3
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row justify-content-md-center"&gt;
        &lt;div class="col col-lg-2"&gt;
            1 of 3
        &lt;/div&gt;
        &lt;div class="col-md-auto"&gt;
            Variable width content
        &lt;/div&gt;
        &lt;div class="col col-lg-2"&gt;
            3 of 3
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            1 of 3
        &lt;/div&gt;
        &lt;div class="col-md-auto"&gt;
            Variable width content
        &lt;/div&gt;
        &lt;div class="col col-lg-2"&gt;
            3 of 3
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Variable width content Ends-->

<!--Equal-width multi-row Starts-->
<section id="equal-width-multi-row" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Equal-width multi-row</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>Create equal-width columns that span multiple rows by inserting a <code>.w-100</code> where you want the columns to break to a new line. Make the breaks responsive by mixing the <code>.w-100</code> with some <a href="https://getbootstrap.com/docs/4.4/utilities/display/">responsive display utilities</a>.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col">col</div>
                  <div class="col">col</div>
                  <div class="w-100"></div>
                  <div class="col">col</div>
                  <div class="col">col</div>
                </div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
    &lt;div class="w-100"&gt;&lt;/div&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Equal-width multi-row Ends-->

<!--Responsive classes Starts-->
<section id="responsive-classes" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Responsive classes</h3>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p class="m-0">Bootstrap’s grid includes five tiers of predefined classes for building complex responsive layouts. Customize the size of your columns on extra small, small, medium, large, or extra large devices however you see fit.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Responsive classes Ends-->

<!--All breakpoints Starts-->
<section id="all-breakpoints" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">All breakpoints</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
        <p>For grids that are the same from the smallest of devices to the largest, use the <code>.col</code> and <code class="highlighter-rouge">.col-*</code> classes. Specify a numbered class when you need a particularly sized column; otherwise, feel free to stick to <code class="highlighter-rouge">.col</code>.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="bd-example">
                <div class="container">
                  <div class="row">
                    <div class="col">col</div>
                    <div class="col">col</div>
                    <div class="col">col</div>
                    <div class="col">col</div>
                  </div>
                  <div class="row">
                    <div class="col-8">col-8</div>
                    <div class="col-4">col-4</div>
                  </div>
                </div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
    &lt;div class="col"&gt;col&lt;/div&gt;
&lt;/div&gt;
&lt;div class="row"&gt;
    &lt;div class="col-8"&gt;col-8&lt;/div&gt;
    &lt;div class="col-4"&gt;col-4&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--All breakpoints Ends-->

<!--Stacked to horizontal Starts-->
<section id="stacked-to-horizontal" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Stacked to horizontal</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>Don’t want your columns to simply stack in some grid tiers? Use a combination of different classes for each tier as needed. See the example below for a better idea of how it all works.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <!-- Stack the columns on mobile by making one full-width and the other half-width -->
                <div class="row">
                  <div class="col-12 col-md-8">.col-12 .col-md-8</div>
                  <div class="col-6 col-md-4">.col-6 .col-md-4</div>
                </div>

                <!-- Columns start at 50% wide on mobile and bump up to 33.3% wide on desktop -->
                <div class="row">
                  <div class="col-6 col-md-4">.col-6 .col-md-4</div>
                  <div class="col-6 col-md-4">.col-6 .col-md-4</div>
                  <div class="col-6 col-md-4">.col-6 .col-md-4</div>
                </div>

                <!-- Columns are always 50% wide, on mobile and desktop -->
                <div class="row">
                  <div class="col-6">.col-6</div>
                  <div class="col-6">.col-6</div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;!-- Stack the columns on mobile by making one full-width and the other half-width --&gt;
&lt;div class="row"&gt;
    &lt;div class="col-12 col-md-8"&gt;.col-12 .col-md-8&lt;/div&gt;
    &lt;div class="col-6 col-md-4"&gt;.col-6 .col-md-4&lt;/div&gt;
&lt;/div&gt;

&lt;!-- Columns start at 50% wide on mobile and bump up to 33.3% wide on desktop --&gt;
&lt;div class="row"&gt;
    &lt;div class="col-6 col-md-4"&gt;.col-6 .col-md-4&lt;/div&gt;
    &lt;div class="col-6 col-md-4"&gt;.col-6 .col-md-4&lt;/div&gt;
    &lt;div class="col-6 col-md-4"&gt;.col-6 .col-md-4&lt;/div&gt;
&lt;/div&gt;

&lt;!-- Columns are always 50% wide, on mobile and desktop --&gt;
&lt;div class="row"&gt;
    &lt;div class="col-6"&gt;.col-6&lt;/div&gt;
    &lt;div class="col-6"&gt;.col-6&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Stacked to horizontal Ends-->

<!--Vertical alignment-->
<section id="vertical-alignment" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Vertical alignment</h4>
      </div>
      <div class="card-body">
        <div class="card-content">

          <div class="bd-example-row bd-example-row-flex-cols">
            <div class="bd-example">
              <div class="container">
                <div class="row align-items-start">
                  <div class="col">
                    One of three columns
                  </div>
                  <div class="col">
                    One of three columns
                  </div>
                  <div class="col">
                    One of three columns
                  </div>
                </div>
                <div class="row align-items-center">
                  <div class="col">
                    One of three columns
                  </div>
                  <div class="col">
                    One of three columns
                  </div>
                  <div class="col">
                    One of three columns
                  </div>
                </div>
                <div class="row align-items-end">
                  <div class="col">
                    One of three columns
                  </div>
                  <div class="col">
                    One of three columns
                  </div>
                  <div class="col">
                    One of three columns
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup my-3"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row align-items-start"&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row align-items-center"&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row align-items-end"&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col"&gt;
            One of three columns
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>

          <div class="bd-example-row bd-example-row-flex-cols">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col align-self-start">
                    One of three columns
                  </div>
                  <div class="col align-self-center">
                    One of three columns
                  </div>
                  <div class="col align-self-end">
                    One of three columns
                  </div>
                </div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row"&gt;
        &lt;div class="col align-self-start"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col align-self-center"&gt;
            One of three columns
        &lt;/div&gt;
        &lt;div class="col align-self-end"&gt;
            One of three columns
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Vertical alignment-->

<!--Horizontal alignment-->
<section id="horizontal-alignment" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Horizontal alignment</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row justify-content-start">
                  <div class="col-4">
                    One of two columns
                  </div>
                  <div class="col-4">
                    One of two columns
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-4">
                    One of two columns
                  </div>
                  <div class="col-4">
                    One of two columns
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-4">
                    One of two columns
                  </div>
                  <div class="col-4">
                    One of two columns
                  </div>
                </div>
                <div class="row justify-content-around">
                  <div class="col-4">
                    One of two columns
                  </div>
                  <div class="col-4">
                    One of two columns
                  </div>
                </div>
                <div class="row justify-content-between">
                  <div class="col-4">
                    One of two columns
                  </div>
                  <div class="col-4">
                    One of two columns
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row justify-content-start"&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row justify-content-center"&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row justify-content-end"&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row justify-content-around"&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="row justify-content-between"&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
        &lt;div class="col-4"&gt;
            One of two columns
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Horizontal alignment-->

<!--No gutters-->
<section id="no-gutters" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">No gutters</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>The gutters between columns in our predefined grid classes can be removed with <code class="highlighter-rouge">.no-gutters</code>. This removes the negative <code class="highlighter-rouge">margin</code>s from <code class="highlighter-rouge">.row</code> and the horizontal <code class="highlighter-rouge">padding</code> from all immediate children columns.</p>
          <p>Here’s the source code for creating these styles. Note that column overrides are scoped to only the first children columns and are targeted via <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/Attribute_selectors">attribute selector</a>. While this generates a more specific selector, column padding can still be further customized with <a href="https://getbootstrap.com/docs/4.4/utilities/spacing/">spacing utilities</a>.</p>
          <p><strong>Need an edge-to-edge design?</strong> Drop the parent <code class="highlighter-rouge">.container</code> or <code class="highlighter-rouge">.container-fluid</code>.</p>
          <div class="bd-example-row">
            <pre class="language-css my-3"><code class="language-css">.no-gutters &#123;
    margin-right: 0;
    margin-left: 0;

    > .col,
    > [class*="col-"] &#123;
    padding-right: 0;
    padding-left: 0;
    &#125;
&#125;</code></pre>
          </div>
          <p>In practice, here’s how it looks. Note you can continue to use this with all other predefined grid classes
            (including column widths, responsive tiers, reorders, and more).</p>
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="row no-gutters">
                <div class="col-12 col-sm-6 col-md-8">.col-12 .col-sm-6 .col-md-8</div>
                <div class="col-6 col-md-4">.col-6 .col-md-4</div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row no-gutters"&gt;
    &lt;div class="col-12 col-sm-6 col-md-8"&gt;.col-12 .col-sm-6 .col-md-8&lt;/div&gt;
    &lt;div class="col-6 col-md-4"&gt;.col-6 .col-md-4&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--No gutters-->

<!--Column wrapping-->
<section id="column-wrapping" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Column wrapping</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>If more than 12 columns are placed within a single row, each group of extra columns will, as one unit, wrap onto a new line.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col-9">.col-9</div>
                  <div class="col-4">.col-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new
                    line as one contiguous unit.</div>
                  <div class="col-6">.col-6<br>Subsequent columns continue along the new line.</div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-9"&gt;.col-9&lt;/div&gt;
    &lt;div class="col-4"&gt;.col-4&lt;br&gt;Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.&lt;/div&gt;
    &lt;div class="col-6"&gt;.col-6&lt;br&gt;Subsequent columns continue along the new line.&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Column wrapping-->

<!--Column breaks-->
<section id="column-breaks" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Column breaks</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>Breaking columns to a new line in flexbox requires a small hack: add an element with <code class="highlighter-rouge">width: 100%</code> wherever you want to wrap your columns to a new line. Normally this is accomplished with multiple <code class="highlighter-rouge">.row</code>s, but not ever implementation method can account for this.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col-6 col-sm-3">.col-6 .col-sm-3</div>
                  <div class="col-6 col-sm-3">.col-6 .col-sm-3</div>

                  <!-- Force next columns to break to new line -->
                  <div class="w-100"></div>

                  <div class="col-6 col-sm-3">.col-6 .col-sm-3</div>
                  <div class="col-6 col-sm-3">.col-6 .col-sm-3</div>
                </div>
              </div>
            </div>

            <pre class="language-markup my-3"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-6 col-sm-3"&gt;.col-6 .col-sm-3&lt;/div&gt;
    &lt;div class="col-6 col-sm-3"&gt;.col-6 .col-sm-3&lt;/div&gt;

    &lt;!-- Force next columns to break to new line --&gt;
    &lt;div class="w-100"&gt;&lt;/div&gt;

    &lt;div class="col-6 col-sm-3"&gt;.col-6 .col-sm-3&lt;/div&gt;
    &lt;div class="col-6 col-sm-3"&gt;.col-6 .col-sm-3&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
          <p>You may also apply this break at specific breakpoints with our <a href="https://getbootstrap.com/docs/4.4/utilities/display/">responsive
              display utilities</a>.</p>
          <div class="bd-example-row">

            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col-6 col-sm-4">.col-6 .col-sm-4</div>
                  <div class="col-6 col-sm-4">.col-6 .col-sm-4</div>

                  <!-- Force next columns to break to new line at md breakpoint and up -->
                  <div class="w-100 d-none d-md-block"></div>

                  <div class="col-6 col-sm-4">.col-6 .col-sm-4</div>
                  <div class="col-6 col-sm-4">.col-6 .col-sm-4</div>
                </div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-6 col-sm-4"&gt;.col-6 .col-sm-4&lt;/div&gt;
    &lt;div class="col-6 col-sm-4"&gt;.col-6 .col-sm-4&lt;/div&gt;

    &lt;!-- Force next columns to break to new line at md breakpoint and up --&gt;
    &lt;div class="w-100 d-none d-md-block"&gt;&lt;/div&gt;

    &lt;div class="col-6 col-sm-4"&gt;.col-6 .col-sm-4&lt;/div&gt;
    &lt;div class="col-6 col-sm-4"&gt;.col-6 .col-sm-4&lt;/div&gt;
&lt;/div&gt;</code></pre>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Column breaks-->


<!--Reordering-->
<section id="reordering" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Reordering</h3>
        <h5 class="card-text mt-2">Order Classes</h5>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>Use <code>.order-</code> classes for controlling the <strong>visual order</strong> of your content. These classes are responsive, so you can set the <code>order</code> by breakpoint (e.g., <code>.order-1.order-md-2</code>). Includes support for <code>1</code> through <code>12</code> across all five grid tiers.</p>
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col">
                    First, but unordered
                  </div>
                  <div class="col order-12">
                    Second, but last
                  </div>
                  <div class="col order-1">
                    Third, but first
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup my-3"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            First, but unordered
        &lt;/div&gt;
        &lt;div class="col order-12"&gt;
            Second, but last
        &lt;/div&gt;
        &lt;div class="col order-1"&gt;
        Third, but first
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>

          <p>There’s also a responsive <code>.order-first</code> class that quickly changes the order of one element by
            applying <code>order: -1</code>. This class can also be intermixed with the numbered <code>.order-*</code>
            classes as needed.</p>
          <div class="bd-example-row">

            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col">
                    First, but unordered
                  </div>
                  <div class="col">
                    Second, but unordered
                  </div>
                  <div class="col order-first">
                    Third, but first
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="container"&gt;
    &lt;div class="row"&gt;
        &lt;div class="col"&gt;
            First, but unordered
        &lt;/div&gt;
        &lt;div class="col"&gt;
            Second, but unordered
        &lt;/div&gt;
        &lt;div class="col order-first"&gt;
            Third, but first
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Reordering-->


<!--Offsetting columns-->
<section id="offsetting-columns" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Offsetting columns</h3>
        <h5 class="mt-2">Offset classes</h5>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p class="card-text">You can offset grid columns in two ways: our responsive <code>.offset-</code> grid classes and our <a href="https://getbootstrap.com/docs/4.4/utilities/spacing/">margin utilities</a>. Grid classes are sized to match columns while margins are more useful for quick layouts where the width of the offset is variable.</p>
          <p>Move columns to the right using <code>.offset-md-*</code> classes. These classes increase the left margin of a column by <code>*</code> columns. For example, <code>.offset-md-4</code> moves <code>.col-md-4</code> over four columns.</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col-md-4">.col-md-4</div>
                  <div class="col-md-4 offset-md-4">.col-md-4 .offset-md-4</div>
                </div>
                <div class="row">
                  <div class="col-md-3 offset-md-3">.col-md-3 .offset-md-3</div>
                  <div class="col-md-3 offset-md-3">.col-md-3 .offset-md-3</div>
                </div>
                <div class="row">
                  <div class="col-md-6 offset-md-3">.col-md-6 .offset-md-3</div>
                </div>
              </div>
            </div>

            <pre class="language-markup my-3"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-md-4"&gt;.col-md-4&lt;/div&gt;
    &lt;div class="col-md-4 offset-md-4"&gt;.col-md-4 .offset-md-4&lt;/div&gt;
&lt;/div&gt;
&lt;div class="row"&gt;
    &lt;div class="col-md-3 offset-md-3"&gt;.col-md-3 .offset-md-3&lt;/div&gt;
    &lt;div class="col-md-3 offset-md-3"&gt;.col-md-3 .offset-md-3&lt;/div&gt;
&lt;/div&gt;
&lt;div class="row"&gt;
    &lt;div class="col-md-6 offset-md-3"&gt;.col-md-6 .offset-md-3&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>

          <p>In addition to column clearing at responsive breakpoints, you may need to reset offsets. See this in
            action in <a href="https://getbootstrap.com/docs/4.4/layout/grid/">the grid example</a>.</p>
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="bd-example">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-5 col-md-6">.col-sm-5 .col-md-6</div>
                    <div class="col-sm-5 offset-sm-2 col-md-6 offset-md-0">.col-sm-5 .offset-sm-2 .col-md-6
                      .offset-md-0</div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6 col-md-5 col-lg-6">.col.col-sm-6.col-md-5.col-lg-6</div>
                    <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">.col-sm-6 .col-md-5 .offset-md-2
                      .col-lg-6 .offset-lg-0</div>
                  </div>
                </div>
              </div>
            </div>
            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-sm-5 col-md-6"&gt;.col-sm-5 .col-md-6&lt;/div&gt;
    &lt;div class="col-sm-5 offset-sm-2 col-md-6 offset-md-0"&gt;.col-sm-5 .offset-sm-2 .col-md-6 .offset-md-0&lt;/div&gt;
&lt;/div&gt;

&lt;div class="row"&gt;
    &lt;div class="col-sm-6 col-md-5 col-lg-6"&gt;.col.col-sm-6.col-md-5.col-lg-6&lt;/div&gt;
    &lt;div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0"&gt;.col-sm-6 .col-md-5 .offset-md-2 .col-lg-6 .offset-lg-0&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Offsetting columns-->

<!--Margin utilities-->
<section id="margin-utilities" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Margin utilities</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>With the move to flexbox in v4, you can use margin utilities like <code class="highlighter-rouge">.mr-auto</code> to force sibling columns away from one another.</p>
          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col-md-4">.col-md-4</div>
                  <div class="col-md-4 ml-auto">.col-md-4 .ml-auto</div>
                </div>
                <div class="row">
                  <div class="col-md-3 ml-md-auto">.col-md-3 .ml-md-auto</div>
                  <div class="col-md-3 ml-md-auto">.col-md-3 .ml-md-auto</div>
                </div>
                <div class="row">
                  <div class="col-auto mr-auto">.col-auto .mr-auto</div>
                  <div class="col-auto">.col-auto</div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-md-4"&gt;.col-md-4&lt;/div&gt;
    &lt;div class="col-md-4 ml-auto"&gt;.col-md-4 .ml-auto&lt;/div&gt;
&lt;/div&gt;
&lt;div class="row"&gt;
    &lt;div class="col-md-3 ml-md-auto"&gt;.col-md-3 .ml-md-auto&lt;/div&gt;
    &lt;div class="col-md-3 ml-md-auto"&gt;.col-md-3 .ml-md-auto&lt;/div&gt;
&lt;/div&gt;
&lt;div class="row"&gt;
    &lt;div class="col-auto mr-auto"&gt;.col-auto .mr-auto&lt;/div&gt;
    &lt;div class="col-auto"&gt;.col-auto&lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Margin utilities-->

<!--Nesting-->
<section id="nesting" class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Nesting</h4>
      </div>
      <div class="card-body">
        <div class="card-content">
          <p>To nest your content with the default grid, add a new <code class="highlighter-rouge">.row</code> and set of <code class="highlighter-rouge">.col-sm-*</code> columns within an existing <code class="highlighter-rouge">.col-sm-*</code> column. Nested rows should include a set of columns that add up to 12 or fewer (it is not required that you use all 12 available columns).</p>

          <div class="bd-example-row">
            <div class="bd-example">
              <div class="container">
                <div class="row">
                  <div class="col-sm-9">
                    Level 1: .col-sm-9
                    <div class="row">
                      <div class="col-8 col-sm-6">
                        Level 2: .col-8 .col-sm-6
                      </div>
                      <div class="col-4 col-sm-6">
                        Level 2: .col-4 .col-sm-6
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <pre class="language-markup mt-3 mb-0"><code class="language-markup">&lt;div class="row"&gt;
    &lt;div class="col-sm-9"&gt;
        Level 1: .col-sm-9
        &lt;div class="row"&gt;
            &lt;div class="col-8 col-sm-6"&gt;
            Level 2: .col-8 .col-sm-6
            &lt;/div&gt;
            &lt;div class="col-4 col-sm-6"&gt;
            Level 2: .col-4 .col-sm-6
            &lt;/div&gt;
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
